module.exports = "<div class=\"action-header-btn dropdown q-dropdown q-block-at-md overflow-dropdown dropdown-parent-header\"> <a class=\"base-btn purple-btn q-block-at-md disabled\" href=# data-toggle=dropdown role=button aria-haspopup=true aria-expanded=true> <div class=btn-text-wrap> <span class=btn-text> Actions <span class=\"fa fa-chevron-down q-marg-left-xxxs\"></span> </span> </div> </a> <ul class=\"dropdown-menu q-dropdown-left q-dropdown-no-max q-dropdown-full-at-mid overflow-dropdown-menu\" data-parent-index=header> {%= list %} </ul> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html
// module id = 30
// module chunks = 1